import React, { useEffect, useState } from "react";
import Select from "react-select";
import { fetchActionsUtil, maturityTime } from "../../utils";
import { toast } from "react-toastify";
import { URLS } from "../urls";

const token = "dummy token";

const DisplayMainLeave = ({ leave, branches, updateLeavesList }) => {
  const [total, setTotal] = useState(0);
  const [state, setState] = useState({});
  const [initialLeaves, setInitialLeaves] = useState({
    editLeaveField: {},
    rsvLeavesSet: {},
  });

  useEffect(() => {
    const policy = leave?.customPolicies?.reduce((acc, curr) => {
      return acc + curr?.days;
    }, 0);
    setTotal(policy || 0);
  }, [leave.customPolicies]);

  useEffect(() => {
    const updatedLeave = Object.keys(leave).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});
    setInitialLeaves({
      editLeaveField: updatedLeave,
      rsvLeavesSet: JSON.parse(JSON.stringify(leave)),
    });

    setState(leave);
  }, [leave]);

  const saveLeaveBranches = async (fieldType) => {
    if (state.carry && state?.duration === 0) {
      return toast.error("Add validity after leave year");
    }

    try {
      const response = await fetchActionsUtil(
        `${URLS.backendLeaves}/update`,
        "POST",
        token,
        { leave: state }
      );

      if (response.success) {
        let updatedLeave = response.leave;
        updatedLeave.customPolicies = leave.customPolicies;
        updateLeavesList(updatedLeave);

        setInitialLeaves((prev) => {
          const updatedEditLeaveField = {
            ...prev.editLeaveField,
            [fieldType]: false,
          };

          return { ...prev, editLeaveField: updatedEditLeaveField };
        });

        toast.success(response?.message);
      } else {
        console.log(response);
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error saving leave:", error);
      toast.error("An error occurred while saving leave.");
    }
  };

  const saveLeave = async (fieldType) => {
    if (state.carry && state?.duration === 0) {
      return toast.error("Add validity after leave year");
    }

    try {
      const response = await fetchActionsUtil(
        `${URLS.backendLeaves}/update/details`,
        "POST",
        token,
        { leave: state }
      );

      if (response.success) {
        let updatedLeave = response.leave;
        updatedLeave.customPolicies = leave.customPolicies;
        updateLeavesList(updatedLeave);

        setInitialLeaves((prev) => {
          const updatedEditLeaveField = {
            ...prev.editLeaveField,
            [fieldType]: false,
          };
          if (fieldType === "maturity") {
            updatedEditLeaveField.numberYearMonth = false;
            updatedEditLeaveField.yearMonth = false;
          }
          return { ...prev, editLeaveField: updatedEditLeaveField };
        });

        toast.success(response?.message);
      } else {
        console.log(response);
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error saving leave:", error);
      toast.error("An error occurred while saving leave.");
    }
  };

  const OnEdit = (name) => {
    setInitialLeaves((prev) => {
      const updatedEditLeaveField = { ...prev.editLeaveField, [name]: true };
      if (name === "carry") {
        updatedEditLeaveField.duration = true;
      } else if (name === "numberYearMonth") {
        updatedEditLeaveField.yearMonth = true;
      }
      return { ...prev, editLeaveField: updatedEditLeaveField };
    });
  };

  const onCancel = (name) => {
    setInitialLeaves((prev) => {
      const updatedEditLeaveField = { ...prev.editLeaveField, [name]: false };
      if (name === "carry") {
        updatedEditLeaveField.duration = false;
      } else if (name === "numberYearMonth") {
        updatedEditLeaveField.yearMonth = false;
      }
      setState((prevState) => {
        const updatedState = { ...prevState, [name]: prev.rsvLeavesSet[name] };
        if (name === "carry") {
          updatedState.duration = prev.rsvLeavesSet.duration;
          updatedState.carryMax = prev.rsvLeavesSet.carryMax;
        } else if (name === "numberYearMonth") {
          updatedEditLeaveField.yearMonth = prev.rsvLeavesSet.yearMonth;
        }

        return updatedState;
      });
      return { ...prev, editLeaveField: updatedEditLeaveField };
    });
  };

  const updateLeavesInputs = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const updateLeaveSwitch = (name) => {
    setState((prevState) => {
      const updatedState = { ...prevState, [name]: !prevState[name] };

      if (name === "carry" && !prevState.carry) {
        updatedState.duration = 0;
      } else if (name === "prorated") {
        // updatedState.duration = 0;
        // updatedState.carry = false;
        // updatedState.neverExpire = !prevState.prorated;
      } else if (name === "neverExpire" && !prevState.neverExpire) {
        updatedState.duration = 0;
        updatedState.carry = false;
      }

      return updatedState;
    });
  };

  const updateLeavesBranch = (selected) => {
    setState((prevState) => ({
      ...prevState,
      branches: selected,
    }));
  };

  const { editLeaveField } = initialLeaves;

  return (
    <div className="leave-item">
      {/* <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label>Days</label>
              <input
                type="text"
                className="form-control"
                disabled={!editLeaveFields[leave._id]["days"]}
                value={leave.days}
                onChange={updateLeaveDays(leave)}
              />
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveFields[leave._id]["days"]}
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
            onClick={editLeaveDays(leave)}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["days"]}
            className="btn btn-white "
            onClick={cancelSaveLeaveDays(leave)}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveFields[leave._id]["days"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={saveLeaveDays(leave, "days")}
          >
            Save
          </button>
        </div>
      </div> */}

      <div className="d-flex justify-content-center align-items-center leave-row my-4">
        <div>
          <p className="d-block fw-bold h4">
            {total > 1 ? `${total} days` : `${total} day`} total leave
          </p>
        </div>
      </div>
      {!state?.neverExpire ? (
        <>
          <div className="leave-row">
            <div className="leave-left">
              <div className="input-box">
                <label className="d-block">Carry forward</label>

                <div
                  className="onoffswitch"
                  style={{
                    marginLeft: "0",
                    marginRight: "auto",
                    pointerEvents: !editLeaveField["carry"] ? "none" : "",
                    Opacity: !editLeaveField["carry"] ? "0.5" : "",
                  }}
                >
                  <input
                    type="checkbox"
                    name="onoffswitch"
                    className="onoffswitch-checkbox"
                    id="switch_hospitalisation"
                    checked={state?.carry}
                    disabled={!editLeaveField["carry"]}
                  />
                  <label
                    className="onoffswitch-label"
                    for="switch_hospitalisation"
                    onClick={() => updateLeaveSwitch("carry")}
                    disabled={!editLeaveField["carry"]}
                  >
                    <span className="yesnoswitch-inner"></span>
                    <span className="onoffswitch-switch"></span>
                  </label>
                </div>
              </div>
            </div>
            <div className="leave-right-custom">
              <button
                hidden={editLeaveField["carry"]}
                className="leave-edit-btn-custom"
                disabled={state?.isActive ? true : false}
                onClick={() => OnEdit("carry")}
              >
                Edit
              </button>
              <button
                hidden={!editLeaveField["carry"]}
                className="btn btn-white "
                onClick={() => onCancel("carry")}
              >
                Cancel
              </button>
              <button
                hidden={!editLeaveField["carry"]}
                className="btn btn-primary leave-save-btn"
                type="submit"
                onClick={() => saveLeave("carry")}
              >
                Save
              </button>
            </div>
          </div>

          {/*  */}
          <div className="leave-row">
            <div className="leave-left">
              <div className="input-box">
                <div className="form-group">
                  <label>Validity after leave year</label>
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control"
                      disabled={!editLeaveField["duration"]}
                      value={state?.duration}
                      name="duration"
                      onChange={updateLeavesInputs}
                    />
                    <p className="mx-3 fw-bold">Months</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="leave-right-custom">
              <button
                hidden={editLeaveField["duration"]}
                className="leave-edit-btn-custom"
                disabled={state?.isActive ? true : false}
                onClick={() => OnEdit("duration")}
              >
                Edit
              </button>
              <button
                hidden={!editLeaveField["duration"]}
                className="btn btn-white "
                onClick={() => onCancel("duration")}
              >
                Cancel
              </button>
              <button
                hidden={!editLeaveField["duration"]}
                className="btn btn-primary leave-save-btn"
                type="submit"
                onClick={() => saveLeave("duration")}
              >
                Save
              </button>
            </div>
          </div>
        </>
      ) : null}

      {/* <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <label className="d-block">Earned leave</label>
            <div className="leave-inline-form">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id={"inlineRadio1" + idx}
                  value="option1"
                  disabled
                  checked={!leave.earned}
                />
                <label className="form-check-label" for={"inlineRadio1" + idx}>
                  No
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id={"inlineRadio2" + idx}
                  value="option2"
                  disabled
                  checked={leave.earned}
                />
                <label className="form-check-label" for={"inlineRadio2" + idx}>
                  Yes
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            className="leave-edit-btn-custom"
            disabled={leave.isActive ? true : false}
          >
            Edit
          </button>
        </div>
      </div> */}
      {/* ----------------- Branch */}
      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label>Select Branch</label>

              <Select
                closeMenuOnSelect={true}
                isMulti
                isSearchable={true}
                value={branches?.filter((d) =>
                  state?.branches?.find((e) => e.value === d.value)
                )}
                onChange={(selected) => {
                  updateLeavesBranch(selected);
                }}
                isDisabled={!editLeaveField["branches"]}
                options={branches}
              />
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveField["branches"]}
            className="leave-edit-btn-custom"
            disabled={state?.isActive ? true : false}
            onClick={() => OnEdit("branches")}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveField["branches"]}
            className="btn btn-white "
            onClick={() => onCancel("branches")}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveField["branches"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={() => saveLeaveBranches("branches")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}

      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label>Maturity Period</label>

              <div className="row">
                <div className="col-6">
                  <label>Period:</label>
                  <input
                    type="number"
                    placeholder="Number of months/years"
                    value={state?.numberYearMonth}
                    name="numberYearMonth"
                    className="form-control"
                    onChange={updateLeavesInputs}
                    disabled={!editLeaveField["numberYearMonth"]}
                  />
                </div>
                <div className="col-6">
                  <label>Month/Year:</label>
                  <select
                    className="form-control"
                    aria-label="Default select example"
                    name="yearMonth"
                    value={state?.yearMonth}
                    onChange={updateLeavesInputs}
                    disabled={!editLeaveField["yearMonth"]}
                  >
                    {maturityTime.map((a, i) => (
                      <option key={i} value={a.value}>
                        {a.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={
              editLeaveField["yearMonth"] || editLeaveField["numberYearMonth"]
            }
            className="leave-edit-btn-custom"
            disabled={state?.isActive ? true : false}
            onClick={() => OnEdit("numberYearMonth")}
          >
            Edit
          </button>
          <button
            hidden={
              !editLeaveField["numberYearMonth"] || !editLeaveField["yearMonth"]
            }
            className="btn btn-white "
            onClick={() => onCancel("numberYearMonth")}
          >
            Cancel
          </button>
          <button
            hidden={
              !editLeaveField["numberYearMonth"] || !editLeaveField["yearMonth"]
            }
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={() => saveLeave("maturity")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}

      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label className="col-form-label">Prorated</label>
              <div
                className="onoffswitch"
                style={{
                  marginLeft: "0",
                  marginRight: "auto",
                  pointerEvents: !editLeaveField["prorated"] ? "none" : "",
                  Opacity: !editLeaveField["prorated"] ? "0.5" : "",
                }}
              >
                <input
                  type="checkbox"
                  name="onoffswitch"
                  className="onoffswitch-checkbox"
                  id="switch_hospitalisation"
                  checked={state?.prorated}
                  disabled={!editLeaveField["prorated"]}
                />
                <label
                  className="onoffswitch-label"
                  for="switch_hospitalisation"
                  onClick={() => updateLeaveSwitch("prorated")}
                  disabled={!editLeaveField["prorated"]}
                >
                  <span className="yesnoswitch-inner"></span>
                  <span className="onoffswitch-switch"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveField["prorated"]}
            className="leave-edit-btn-custom"
            disabled={state?.isActive ? true : false}
            onClick={() => OnEdit("prorated")}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveField["prorated"]}
            className="btn btn-white "
            onClick={() => onCancel("prorated")}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveField["prorated"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={() => saveLeave("prorated")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}

      {!state?.prorated ? (
        <div className="leave-row">
          <div className="leave-left">
            <div className="input-box">
              <div className="form-group">
                <label className="col-form-label">Never Expire</label>
                <div
                  className="onoffswitch"
                  style={{
                    marginLeft: "0",
                    marginRight: "auto",
                    pointerEvents: !editLeaveField["neverExpire"] ? "none" : "",
                    Opacity: !editLeaveField["neverExpire"] ? "0.5" : "",
                  }}
                >
                  <input
                    type="checkbox"
                    name="onoffswitch"
                    className="onoffswitch-checkbox"
                    id="switch_hospitalisation"
                    checked={state?.neverExpire}
                    disabled={!editLeaveField["neverExpire"]}
                  />
                  <label
                    className="onoffswitch-label"
                    for="switch_hospitalisation"
                    onClick={() => updateLeaveSwitch("neverExpire")}
                    disabled={!editLeaveField["neverExpire"]}
                  >
                    <span className="yesnoswitch-inner"></span>
                    <span className="onoffswitch-switch"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="leave-right-custom">
            <button
              hidden={editLeaveField["neverExpire"]}
              className="leave-edit-btn-custom"
              disabled={state?.isActive ? true : false}
              onClick={() => OnEdit("neverExpire")}
            >
              Edit
            </button>
            <button
              hidden={!editLeaveField["neverExpire"]}
              className="btn btn-white "
              onClick={() => onCancel("neverExpire")}
            >
              Cancel
            </button>
            <button
              hidden={!editLeaveField["neverExpire"]}
              className="btn btn-primary leave-save-btn"
              type="submit"
              onClick={() => saveLeave("neverExpire")}
            >
              Save
            </button>
          </div>
        </div>
      ) : null}

      {/*  */}

      <div className="leave-row">
        <div className="leave-left">
          <div className="input-box">
            <div className="form-group">
              <label className="col-form-label">Backdate</label>
              <div
                className="onoffswitch"
                style={{
                  marginLeft: "0",
                  marginRight: "auto",
                  pointerEvents: !editLeaveField["backDate"] ? "none" : "",
                  Opacity: !editLeaveField["backDate"] ? "0.5" : "",
                }}
              >
                <input
                  type="checkbox"
                  name="onoffswitch"
                  className="onoffswitch-checkbox"
                  id="switch_hospitalisation"
                  checked={state?.backDate}
                  disabled={!editLeaveField["backDate"]}
                />
                <label
                  className="onoffswitch-label"
                  for="switch_hospitalisation"
                  onClick={() => updateLeaveSwitch("backDate")}
                  disabled={!editLeaveField["backDate"]}
                >
                  <span className="yesnoswitch-inner"></span>
                  <span className="onoffswitch-switch"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="leave-right-custom">
          <button
            hidden={editLeaveField["backDate"]}
            className="leave-edit-btn-custom"
            disabled={state?.isActive ? true : false}
            onClick={() => OnEdit("backDate")}
          >
            Edit
          </button>
          <button
            hidden={!editLeaveField["backDate"]}
            className="btn btn-white "
            onClick={() => onCancel("backDate")}
          >
            Cancel
          </button>
          <button
            hidden={!editLeaveField["backDate"]}
            className="btn btn-primary leave-save-btn"
            type="submit"
            onClick={() => saveLeave("backDate")}
          >
            Save
          </button>
        </div>
      </div>

      {/*  */}
    </div>
  );
};

export default DisplayMainLeave;
